import { Component, OnInit } from '@angular/core';
import {FileItem, FileUploader, ParsedResponseHeaders} from 'ng2-file-upload';
import {createKitForm} from '../kit/kit.component';
import {ActivatedRoute, Router} from '@angular/router';
import {KitService} from '../../services/kit.service';
import {ToasterService} from 'angular2-toaster';
import {FileUploadFactoryService} from '../../services/file-upload-factory.service';

@Component({
  selector: 'app-kit-create',
  templateUrl: './kit-create.component.html',
  styleUrls: ['./kit-create.component.css']
})
export class KitCreateComponent implements OnInit {

  kitForm;
  styles;
  metaDataFields;

  public thumbUploader:FileUploader = new FileUploader({url: ''});
  public bannerUploader:FileUploader = new FileUploader({url: ''});

  constructor(private activeRoute: ActivatedRoute,
              private router: Router,
              private fileUploadFactoryService: FileUploadFactoryService,
              private kitService: KitService, private toasterService: ToasterService) {

    this.kitForm = createKitForm();
    let {styles, metaDataFields} = this.activeRoute.snapshot.data['kitFields'];
    this.styles = styles;
    this.metaDataFields = metaDataFields;


    this.thumbUploader = fileUploadFactoryService.create(
      'file',
      FileUploadFactoryService.uploadUrl()
    );

    this.bannerUploader = fileUploadFactoryService.create(
      'file',
      FileUploadFactoryService.uploadUrl()
    );

    this.thumbUploader.onCompleteItem = (item: FileItem, response: string,
                                    status: number,
                                    headers: ParsedResponseHeaders) => {
      let r = JSON.parse(response);
      this.kitForm.thumbnail = `${r.path}`;
    };

    this.bannerUploader.onCompleteItem = (item: FileItem, response: string,
                                         status: number,
                                         headers: ParsedResponseHeaders) => {
      let r = JSON.parse(response);
      this.kitForm.banner = `${r.path}`;
    };
  }

  createNew() {
    this.kitService.createNew(this.kitForm).subscribe(newKit => {
      this.toasterService.pop('success', 'Success', 'Kit created');
      this.kitForm = createKitForm();

      this.navigateToLibrary();

    }, error => {
      this.toasterService.pop('error', 'Error', error);
    });
  }

  ngOnInit() {
  }
  navigateToLibrary() {
    this.router.navigateByUrl('/dashboard/library');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/kit-create/kit-create.component.ts